import script from "./vmsAffiliationManager.vue?vue&type=script&lang=js"
export * from "./vmsAffiliationManager.vue?vue&type=script&lang=js"

import "./vmsAffiliationManager.vue?vue&type=style&index=0&id=a91fbdc2&scoped=true&lang=css"
import "./vmsAffiliationManager.vue?vue&type=style&index=1&id=a91fbdc2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a91fbdc2"]])

export default __exports__